import React from "react";
import { api } from ".";
import Pusher from "./Pusher";

interface Props {
	children: React.ReactNode;
	forcePusher: React.ReactNode;
}

export const PusherContext = React.createContext<any>({} as any);

export const PusherContextProvider = (props: Props) => {
	const [pusher, setPusher] = React.useState<any>(null)

	React.useEffect(() => {
		if(api.isLoggedIn() && api.accessToken) {
			const pusher = new Pusher(api.accessToken)

			setPusher(pusher)
			pusher.open()
		}
	}, [])

	return (
		<PusherContext.Provider
			value={pusher}
		>
			{props.children}
		</PusherContext.Provider>
	)
}

export default PusherContextProvider;
